function syncPlayButtonState(slide, activeVideo) {
  var playBtn = slide.querySelector('.video-play-btn');
  if (!playBtn || !activeVideo) return;
  var iconPause = playBtn.querySelector('.icon-pause');
  var iconPlay = playBtn.querySelector('.icon-play');
  if (activeVideo.paused) {
    if (iconPause) iconPause.style.display = 'none';
    if (iconPlay) iconPlay.style.display = 'block';
  } else {
    if (iconPause) iconPause.style.display = 'block';
    if (iconPlay) iconPlay.style.display = 'none';
  }
}

function syncMuteButtonState(slide, activeVideo) {
  var muteBtn = slide.querySelector('.video-mute-btn');
  if (!muteBtn || !activeVideo) return;
  var iconUnmuted = muteBtn.querySelector('.icon-unmuted');
  var iconMuted = muteBtn.querySelector('.icon-muted');
  if (activeVideo.muted) {
    if (iconUnmuted) iconUnmuted.style.display = 'none';
    if (iconMuted) iconMuted.style.display = 'block';
  } else {
    if (iconUnmuted) iconUnmuted.style.display = 'block';
    if (iconMuted) iconMuted.style.display = 'none';
  }
}

function getActiveSlideElement() {
  return document.querySelector('.c-slider .swiper-slide-active');
}

function getActiveSlideVideo() {
  var activeSlide = getActiveSlideElement();
  if (!activeSlide) return null;
  return getActiveVideo(activeSlide);
}

function isPrimaryActiveVideo(video) {
  var currentActiveVideo = getActiveSlideVideo();
  return !!(video && currentActiveVideo && video === currentActiveVideo);
}

function pauseAllVideosExcept(allowedVideo) {
  document.querySelectorAll('.c-slider video').forEach(function (video) {
    if (allowedVideo && video === allowedVideo) return;
    video.pause();
  });
}

function resolveControlVideo(button) {
  var activeVideo = getActiveSlideVideo();
  if (activeVideo) return activeVideo;

  var wrapper = button ? button.closest('.video-slide-wrapper') : null;
  if (!wrapper) return null;
  return getActiveVideo(wrapper);
}

var initialMuteEnforced = false;

function enforceInitialMutedAutoplay() {
  if (initialMuteEnforced) return;

  document.querySelectorAll('.c-slider video').forEach(function (video) {
    video.muted = true;
    video.setAttribute('muted', 'muted');
    video.setAttribute('data-original-muted', 'true');
    video.removeAttribute('data-needs-user-unmute');
  });

  initialMuteEnforced = true;
}

var isSlideTransitioning = false;

function isVideoInActiveSlide(video) {
  var slide = video ? video.closest('.swiper-slide') : null;
  return !!(slide && slide.classList.contains('swiper-slide-active'));
}

function shouldAutoRecover(video) {
  if (!video) return false;
  if (!video.hasAttribute('autoplay')) return false;
  if (video.getAttribute('data-user-paused') === 'true') return false;
  if (isSlideTransitioning) return false;
  if (!isVideoInActiveSlide(video)) return false;
  if (!isPrimaryActiveVideo(video)) return false;
  return true;
}

function recoverVideoPlayback(video) {
  if (!shouldAutoRecover(video)) return;
  attemptAutoplay(video, function () {
    var slide = video.closest('.swiper-slide');
    if (!slide) return;
    syncPlayButtonState(slide, video);
    syncMuteButtonState(slide, video);
  });
}

function bindVideoStabilityHandlers() {
  document.querySelectorAll('.c-slider video').forEach(function (video) {
    if (video.getAttribute('data-stability-bound') === 'true') return;
    video.setAttribute('data-stability-bound', 'true');

    video.addEventListener('playing', function () {
      if (video.getAttribute('data-user-paused') !== 'true') {
        video.setAttribute('data-user-paused', 'false');
      }
      if (!isPrimaryActiveVideo(video)) return;
      var slide = video.closest('.swiper-slide');
      if (slide) {
        syncPlayButtonState(slide, video);
        syncMuteButtonState(slide, video);
      }
    });

    video.addEventListener('pause', function () {
      setTimeout(function () {
        recoverVideoPlayback(video);
      }, 150);
    });

    video.addEventListener('ended', function () {
      if (video.hasAttribute('loop')) {
        video.currentTime = 0;
      }
      recoverVideoPlayback(video);
    });

    video.addEventListener('stalled', function () {
      setTimeout(function () {
        recoverVideoPlayback(video);
      }, 300);
    });

    video.addEventListener('suspend', function () {
      setTimeout(function () {
        recoverVideoPlayback(video);
      }, 300);
    });
  });
}

function attemptAutoplay(video, done) {
  if (!video) {
    if (done) done();
    return;
  }

  var onDone = function () {
    if (done) done();
  };

  if (!video.hasAttribute('data-original-muted')) {
    var wasMutedByConfig = video.hasAttribute('muted') || video.muted;
    video.setAttribute('data-original-muted', wasMutedByConfig ? 'true' : 'false');
  }

  var playPromise = video.play();
  if (playPromise && typeof playPromise.then === 'function') {
    playPromise.then(function () {
      onDone();
    }).catch(function () {
      video.muted = true;
      video.setAttribute('muted', 'muted');
      var retryPromise = video.play();
      if (retryPromise && typeof retryPromise.then === 'function') {
        retryPromise.then(function () {
          onDone();
        }).catch(function () {
          onDone();
        });
      } else {
        onDone();
      }
    });
  } else {
    onDone();
  }
}

function playActiveSlideVideo(swiperInstance) {
  if (!swiperInstance || !swiperInstance.slides) return;
  var activeSlide = swiperInstance.el && swiperInstance.el.querySelector
    ? swiperInstance.el.querySelector('.swiper-slide-active')
    : null;
  if (!activeSlide) {
    activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
  }
  if (!activeSlide) return;
  var activeVideo = getActiveVideo(activeSlide);
  if (activeVideo && activeVideo.hasAttribute('autoplay')) {
    pauseAllVideosExcept(activeVideo);
    attemptAutoplay(activeVideo, function () {
      syncPlayButtonState(activeSlide, activeVideo);
      syncMuteButtonState(activeSlide, activeVideo);
      setTimeout(function () {
        syncPlayButtonState(activeSlide, activeVideo);
        syncMuteButtonState(activeSlide, activeVideo);
      }, 80);
    });
  } else {
    pauseAllVideosExcept(null);
    syncPlayButtonState(activeSlide, activeVideo);
    syncMuteButtonState(activeSlide, activeVideo);
  }
}

var swiper = new Swiper('.c-slider', {
  slidesPerView : 1,
  loop: true,
  lazy: true,
  autoHeight: true,
  navigation: {
    nextEl: '.main-button-next',
    prevEl: '.main-button-prev'
  },
  breakpoints: {
    // when window width is <= 991px
    991: {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }

    }
  },
  on: {
    init: function () {
      enforceInitialMutedAutoplay();
      bindVideoStabilityHandlers();
      playActiveSlideVideo(this);
      setTimeout(function () {
        playActiveSlideVideo(swiper);
      }, 120);
    },
    afterInit: function () {
      enforceInitialMutedAutoplay();
      bindVideoStabilityHandlers();
      setTimeout(function () {
        playActiveSlideVideo(swiper);
      }, 250);
    },
    slideChangeTransitionStart: function () {
      isSlideTransitioning = true;
      // Pause all videos when slide changes
      var videos = document.querySelectorAll('.c-slider video');
      videos.forEach(function (video) {
        video.pause();
      });
    },
    slideChangeTransitionEnd: function () {
      isSlideTransitioning = false;
      bindVideoStabilityHandlers();
      playActiveSlideVideo(this);
    }
  }
});

// Helper: get the correct visible video (mobile with fallback to desktop)
function getActiveVideo(context) {
  var wrapper;
  if (context.classList && context.classList.contains('video-slide-wrapper')) {
    wrapper = context;
  } else if (context.querySelector) {
    wrapper = context.querySelector('.video-slide-wrapper');
  }
  if (!wrapper) return null;
  var isMobile = window.innerWidth <= 991;
  var hasMobile = wrapper.getAttribute('data-has-mobile') === 'true';
  if (isMobile && hasMobile) {
    return wrapper.querySelector('.video-mobile');
  }
  // Fallback: always use desktop if no mobile or on desktop
  return wrapper.querySelector('.video-desktop');
}

// Play/Pause and Mute/Unmute controls (delegated to support looped/cloned slides)
function handlePlayToggleButton(btn) {
  var video = resolveControlVideo(btn);
  if (!video) return;
  var slide = video.closest('.swiper-slide') || getActiveSlideElement();
  var wrapper = btn.closest('.video-slide-wrapper');
  var iconPause = btn.querySelector('.icon-pause');
  var iconPlay = btn.querySelector('.icon-play');

  if (video.paused) {
    if (wrapper) {
      wrapper.querySelectorAll('video').forEach(function (vid) {
        vid.setAttribute('data-user-paused', 'false');
      });
    }
    video.setAttribute('data-user-paused', 'false');
    pauseAllVideosExcept(video);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(function () {
        if (iconPause) iconPause.style.display = 'block';
        if (iconPlay) iconPlay.style.display = 'none';
        syncMuteButtonState(slide, video);
      }).catch(function () {
        if (iconPause) iconPause.style.display = 'none';
        if (iconPlay) iconPlay.style.display = 'block';
        syncMuteButtonState(slide, video);
      });
    } else {
      if (iconPause) iconPause.style.display = 'block';
      if (iconPlay) iconPlay.style.display = 'none';
      syncMuteButtonState(slide, video);
    }
  } else {
    if (wrapper) {
      wrapper.querySelectorAll('video').forEach(function (vid) {
        vid.setAttribute('data-user-paused', 'true');
      });
    }
    video.setAttribute('data-user-paused', 'true');
    video.pause();
    if (iconPause) iconPause.style.display = 'none';
    if (iconPlay) iconPlay.style.display = 'block';
    syncMuteButtonState(slide, video);
  }
}

function handleMuteToggleButton(btn) {
  var video = resolveControlVideo(btn);
  if (!video) return;
  var slide = video.closest('.swiper-slide') || getActiveSlideElement();

  var willBeMuted = !video.muted;
  video.muted = willBeMuted;
  if (willBeMuted) {
    video.setAttribute('muted', 'muted');
  } else {
    video.removeAttribute('muted');
    video.removeAttribute('data-needs-user-unmute');
    if (!video.paused) {
      video.play().catch(function () {});
    }
  }

  syncMuteButtonState(slide, video);
}

document.addEventListener('click', function (event) {
  var playBtn = event.target.closest('[data-video-toggle]');
  if (playBtn) {
    event.preventDefault();
    event.stopPropagation();
    handlePlayToggleButton(playBtn);
    return;
  }

  var muteBtn = event.target.closest('[data-video-mute-toggle]');
  if (muteBtn) {
    event.preventDefault();
    event.stopPropagation();
    handleMuteToggleButton(muteBtn);
  }
}, true);

document.addEventListener('touchstart', function (event) {
  if (!event.target.closest('[data-video-toggle], [data-video-mute-toggle]')) return;
  event.stopPropagation();
}, { passive: true, capture: true });

// Handle responsive video switching
(function () {
  var mql = window.matchMedia('(max-width: 991px)');
  function handleVideoSwitch(e) {
    document.querySelectorAll('.video-slide-wrapper').forEach(function (wrapper) {
      var desktopVid = wrapper.querySelector('.video-desktop');
      var mobileVid = wrapper.querySelector('.video-mobile');
      var hasMobile = wrapper.getAttribute('data-has-mobile') === 'true';
      if (desktopVid) desktopVid.pause();
      if (mobileVid) mobileVid.pause();
      // Auto-play the correct video if in active slide
      var slide = wrapper.closest('.swiper-slide');
      if (slide && slide.classList.contains('swiper-slide-active')) {
        var activeVideo;
        if (e.matches && hasMobile) {
          activeVideo = mobileVid;
        } else {
          activeVideo = desktopVid;
        }
        if (activeVideo && activeVideo.hasAttribute('autoplay')) {
          pauseAllVideosExcept(activeVideo);
          attemptAutoplay(activeVideo, function () {});
        }
      }
    });
  }
  if (mql.addEventListener) {
    mql.addEventListener('change', handleVideoSwitch);
  } else {
    mql.addListener(handleVideoSwitch);
  }
  handleVideoSwitch(mql);
})();

document.addEventListener('visibilitychange', function () {
  if (document.visibilityState !== 'visible') return;
  var activeSlide = document.querySelector('.c-slider .swiper-slide-active');
  if (!activeSlide) return;
  var activeVideo = getActiveVideo(activeSlide);
  recoverVideoPlayback(activeVideo);
});